import React from 'react';
import { FaExternalLinkAlt } from 'react-icons/fa';
import { GrCertificate } from 'react-icons/gr';

const CertificateLink = ({ LAB, CERTIFICATE_NO, CERTIFICATE_LINK, className = 'font-size-sm text-primary', withExternalLinkIcon = false, hideLabName = false, hideCerti = false , GrCerti = false}) => {

  return (
    <a
      href={CERTIFICATE_LINK || null}
      target="_blank"
      rel="noopener noreferrer"
      className={className}
    >
      {GrCerti && <GrCertificate className="mr-1 font-size-lg" />}
      {!hideLabName && !hideCerti ?
      `${LAB !== "NON"?`${LAB}:`:""}${CERTIFICATE_NO}` : 
      !hideLabName?`${LAB !== "NON"?LAB:""}`:
      !hideCerti?`${CERTIFICATE_NO}`:
      ""}
      {withExternalLinkIcon && LAB !== "NON" ? <FaExternalLinkAlt className='ml-1' /> : ""}
    </a>
  )
};

export default CertificateLink;
